import {Link} from 'react-router';
import {useFrescuraDeDatos} from '../api/cargas';
import {tr} from '../i18n/idioma';
import {fechaDeInstante} from '../utilidades/formato';
import {AYUDA_INICIO} from './ayuda-general';
import {NotaDeAyuda} from './nota-de-ayuda';

// Fecha de la ultima carga de cada archivo (recorrido 7/10/2026): para saber
// de un vistazo que tan al dia esta cada fuente. Solo informa; sin avisos por
// antiguedad (decision de Daniel).
export function FrescuraDeDatos() {
  const frescura = useFrescuraDeDatos();
  const archivos = frescura.data?.archivos ?? [];
  if (!archivos.length) return null;
  return (
    <section
      className="rounded-lg border border-linea bg-white p-5"
      aria-labelledby="titulo-frescura"
      data-prueba="frescura-de-datos"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 id="titulo-frescura" className="font-medium">
          {tr('Última carga de cada archivo', 'Latest upload of each file')}
          <NotaDeAyuda texto={AYUDA_INICIO.frescura} />
        </h2>
        <Link to="/cargar" className="text-xs text-verde hover:underline">
          {tr('Cargar archivos →', 'Upload files →')}
        </Link>
      </div>
      <ul className="mt-2 grid gap-x-6 gap-y-1 text-sm sm:grid-cols-2 xl:grid-cols-3">
        {archivos.map(a => (
          <li key={a.etiqueta} className="flex items-baseline justify-between gap-3 border-b border-linea/50 py-0.5">
            <span className="truncate" title={a.archivo ?? undefined}>
              {a.etiqueta}
            </span>
            <span className="shrink-0 tabular-nums text-apagado">{fechaDeInstante(a.ultimaCarga)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
